// MediaPage.jsx
import React, { useState } from 'react';
import Slider from 'react-slick';
import '../styles/Media.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { gallery, video } from '../data/gallery';

const MediaPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeView, setActiveView] = useState('images');
      
  const showImages = () =>{
    setActiveView('images');
  }
  
  const showVideos = () =>{
    setActiveView('video')
  }

  const isActive = (view) => activeView === view;

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const sliderSettings = {
    initialSlide: currentIndex,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <>
    <title>Zuri Lands Investment Limited - Media</title>
    <div className="media-page">
      <div className="page_header">
         <h1>Media</h1>
        <p className="header_text"></p>
      </div>
      <div className="button_container">
          <button className={`video_button ${isActive('images') ? 'active' : ''}`} onClick={showImages}>Images</button>
          <button className={`review_button ${isActive('videos') ? 'active' : ''}`} onClick={showVideos}>Videos</button>
      </div>

      {activeView === 'images' ? (
        <div className="image-grid">
          {gallery.map((item, index) => (
            <div className="image-card" key={item.id}>
              <div 
                className="image-container"
                data-tooltip={item.title}
                onClick={() => openModal(index)}
              >
                <img 
                  src={item.url} 
                  alt={item.title} 
                  className="media-image"
                />
              </div>
              <div className="text-container">
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="video-grid">
          {video.map((video) => (
            <div className="video-card" key={video.id}>
              <div className="video-container">
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}?rel=0`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-info">
                <p>{video.title}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={closeModal}>×</button>
            <Slider {...sliderSettings}>
              {gallery.map((item) => (
                <div key={item.id} className="carousel-slide">
                  <img src={item.url} alt={item.title} className="carousel-image" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
    </>
  );
};
export default MediaPage;
